// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__7ZLHS","mobile":"style_mobile__e+oR4","position":"style_position__e0b3c","laptop":"style_laptop__cxZaa","v3":"style_v3__DUQNd"};